<template>
    <div></div>
</template>

<script>
    import {mapGetters, mapActions, mapMutations} from 'vuex'

    export default {
        computed: {
            ...mapGetters({
                identity: 'authGetIdentity'
            })
        },

        mounted() {
            this.check()
        },

        watch: {
            $route() {
                this.check()
            }
        },

        methods: {
            check() {
                const identity = this.identity

                if (!identity) {
                    this.$router.push({
                        name: 'login',
                        query: this.$router.currentRoute.query
                    })
                }
            },
        }
    }
</script>


// WEBPACK FOOTER //
// Home.vue?0b2bcff4